<template>
  <div>
    <div class="page-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  created: () => {
    document.body.setAttribute('data-layout', 'horizontal')
    document.body.setAttribute('data-layout', 'blank')
  },
  methods: {
  }
}
</script>
<style scoped>
</style>
